"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressDescription = void 0;
const ModelDescription_1 = require("../type-descriptions/ModelDescription");
const String_1 = require("../type-descriptions/String");
const filterBoolean_1 = __importDefault(require("../util/filterBoolean"));
exports.addressDescription = (0, ModelDescription_1.modelDescription)({
    properties: {
        city: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
        country: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
        line1: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
        line2: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
        postalCode: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
        region: Object.assign(Object.assign({}, (0, String_1.stringDescription)({ allowNonStringValues: true })), { isOptional: true }),
    },
    userFacingTitle: 'address',
    userFacingValue: value => (0, filterBoolean_1.default)([
        (0, filterBoolean_1.default)([value.line1, value.line2]).join(' '),
        value.city,
        (0, filterBoolean_1.default)([value.region, value.postalCode]).join(' '),
        value.country,
    ]).join(', '),
});
